import styled, { css } from 'styled-components';
import { Button } from '@elfsight/widget-ui';
import { createReadableClass } from '@elfsight/widget-utils';
import { useLingui } from '@lingui/react/macro';
import { useSettings } from '@wu/widget-core';
import type { AppointmentBookingService } from '../../../types';
import { LinkButton } from '../../components/link-button';
import { useResetBookingState } from '../../utils/use-reset-booking-state';
import { useWidgetDimensions } from '../../widget-dimensions-provider';
import { useServices } from '../services-provider';

type ServiceCardActionProps = {
  service: AppointmentBookingService;
};

export const ServiceCardAction = ({ service }: ServiceCardActionProps) => {
  const { t } = useLingui();
  const { accentColor } = useSettings();
  const { currentService, setCurrentService } = useServices();
  const { isMobile, isSmallMobile } = useWidgetDimensions();
  const resetBookingState = useResetBookingState();

  return (
    <Container
      _isSmallMobile={isSmallMobile}
      _isCurrentServiceActive={!!currentService}
    >
      {currentService ? (
        <LinkButton onClick={resetBookingState}>{t`Change`}</LinkButton>
      ) : (
        <BookButton
          fullWidth={isSmallMobile}
          borderWidth={1}
          borderRadius={44}
          verticalPadding={isMobile ? 7 : 9}
          horizontalPadding={isMobile ? 14 : 21}
          mode="outline"
          color={accentColor}
          font={{
            fontSize: isMobile ? 12 : 14,
            fontWeight: 700
          }}
          onClick={() => setCurrentService(service)}
        >
          {t`Book`}
        </BookButton>
      )}
    </Container>
  );
};

const Container = styled.div.attrs({
  className: createReadableClass({
    component: 'service-card-action',
    element: 'container'
  })
})<{
  _isSmallMobile?: boolean;
  _isCurrentServiceActive?: boolean;
}>`
  ${({ _isSmallMobile }) =>
    _isSmallMobile &&
    css`
      width: 100%;
    `}

  ${({ _isSmallMobile, _isCurrentServiceActive }) =>
    _isSmallMobile &&
    _isCurrentServiceActive &&
    css`
      width: auto;
      display: flex;
      justify-content: flex-end;
    `}
`;

const BookButton = styled(Button).attrs({
  className: createReadableClass({
    component: 'service-card-action',
    element: 'book-button'
  })
})``;
